/* eslint-disable @typescript-eslint/no-explicit-any */

export async function runNavigationEventData(sData: Record<string, any>) {
  if ((window as any).onNavigationUserEvent && sData) {
    try {
      await (window as any).onNavigationUserEvent('header', {
        ...sData,
      });
    } catch (e) {
      console.log(
        'onNavigationUserEvent failed - please check the Navigation SEO script JSON and that a SeoInteractionScript is correctly set up.'
      );
    }
  }
}

export function onChangeLanguage(
  isSecondLanguageOnUrl: boolean | undefined,
  secondLanguageUrlPrefix: string | undefined,
  pageBuilderSlugList: string[]
) {
  const pathnameArray = window.location.pathname.split('/');
  if (isSecondLanguageOnUrl) {
    // navigate didn't work as expected in the testing env (that's why I used window.location.href instead)
    window.location.href =
      pathnameArray
        .filter(item => item !== secondLanguageUrlPrefix)
        .join('/') || '/';
  } else {
    const foundSlugIndex = pathnameArray.findIndex(item =>
      pageBuilderSlugList.includes(item)
    );
    if (foundSlugIndex === -1) {
      // homepage
      window.location.href =
        addSlashIfMissing(window.location.pathname) + secondLanguageUrlPrefix;
    } else {
      const convertedPathnameArray = insertStringAt(
        pathnameArray,
        foundSlugIndex,
        secondLanguageUrlPrefix || ''
      );
      window.location.href = convertedPathnameArray.join('/');
    }
  }
}

function insertStringAt(
  array: string[],
  targetIndex: number,
  targetItem: string
) {
  return [
    ...array.slice(0, targetIndex),
    targetItem,
    ...array.slice(targetIndex),
  ];
}

export function addSlashIfMissing(
  target: string,
  { missingFrom = 'end' }: { missingFrom?: 'start' | 'end' } = {}
): string {
  if (missingFrom === 'start' && !target.startsWith('/')) {
    return '/' + target;
  }

  if (missingFrom === 'end' && !target.endsWith('/')) {
    return target + '/';
  }

  return target;
}

export function addHashIfMissing(target: string) {
  if (!target.startsWith('#')) {
    return '#' + target;
  }
  return target;
}
